import React, { forwardRef, useState } from 'react';
import { Command, CommandGroup, CommandItem, CommandList } from '@dashboard/components/ui/command';
import { filterGuideGroups } from './aiGuides';
import GuideBadge from './GuideBadge';

const KEY_HINTS = [
  ['↑↓', 'to choose'],
  ['Enter', 'to open'],
  ['Esc', 'to close'],
];

// The ref is the command root, which handles the arrow keys and Enter.
const GuideMenu = forwardRef(function GuideMenu({ query, groups, onSelect }, ref) {
  const [highlighted, setHighlighted] = useState(null);
  const matches = filterGuideGroups(groups, query);
  const keys = matches.flatMap(group => group.guides.map(guide => guide.key));
  // cmdk keeps a filtered-out value selected, so fall back to the first match.
  const value = keys.includes(highlighted) ? highlighted : (keys[0] ?? '');

  return (
    <Command
      ref={ref}
      label="Guides"
      shouldFilter={false}
      loop
      value={value}
      onValueChange={setHighlighted}
      className="bg-transparent"
    >
      <CommandList className="max-h-72">
        {matches.map(group => (
          <CommandGroup key={group.tab} heading={group.tabLabel}>
            {group.guides.map(guide => (
              <CommandItem
                key={guide.key}
                value={guide.key}
                className="items-start gap-2.5 px-2 py-1.5"
                onSelect={() => onSelect(guide.key)}
              >
                <span className="flex w-40 shrink-0 pt-px">
                  <GuideBadge className="max-w-full">
                    <span className="truncate">{guide.command}</span>
                  </GuideBadge>
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block text-[13px] font-medium leading-[18px]">
                    {guide.section.label}
                  </span>
                  <span className="block text-xs leading-4 text-muted-foreground">
                    {guide.summary}
                  </span>
                </span>
              </CommandItem>
            ))}
          </CommandGroup>
        ))}
      </CommandList>
      <div className="mt-1 flex gap-3.5 border-t px-2 pb-1 pt-2 text-[11px] leading-4 text-muted-foreground">
        {KEY_HINTS.map(([key, hint]) => (
          <span key={key}>
            <kbd className="font-sans font-semibold text-foreground">{key}</kbd> {hint}
          </span>
        ))}
      </div>
    </Command>
  );
});

export default GuideMenu;
